import { Injectable } from '@angular/core';
import { ListService } from 'bookraw/shared/services/list.service';
import { Playlist } from 'bookraw/shared/models/playlist.model';


@Injectable()
export class PlaylistsService extends ListService<Playlist> {
  url: string = '/api/admin/playlists';
}
